import { render, staticRenderFns } from "./modal-registro-incidente.vue?vue&type=template&id=51c199e6&"
import script from "./modal-registro-incidente.vue?vue&type=script&lang=js&"
export * from "./modal-registro-incidente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports